import styled, { css } from 'styled-components';

export const Container = styled.div`
  min-width: 100%;
  overflow: hidden;
  background: #fff;
`;

export const Title = styled.p`
  margin: 0;
  padding: 20px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
`;

export const SelectTabWrapper = styled.div`
  width: calc(100% - 30px);
  margin: 0 15px;
  height: 35px;
  border: 1px solid #78818e;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SelectedTab = styled.div`
  flex: 1;
  height: 100%;
  background: #fff;
  color: #373f4c;
  font-size: 13px;
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.isSelected &&
    css`
      background: #78818e;
      color: #fff;
      font-weight: bold;
    `};
`;

export const SelectedTabText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ToggleButton = styled.div`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  margin-left: auto;
  width: 13px;
  height: 9px;
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: scroll;
`;

export const Table = styled.table`
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;

  margin-top: 15px;
  border: 1px solid #f2f2f2;
  & > thead th {
    height: 36px;
    font-size: 12px;
    text-align: center;
    border-bottom: 1px solid #f2f2f2;
  }

  & > tbody > tr td:first-child {
    text-align: center;
  }
  & > tbody > tr:not(.subRow) td {
    height: 40px;
  }
  & > tbody td.winner {
    color: #ee1a21;
  }

  & > tbody > tr {
    border-bottom: 1px solid #f2f2f2;
  }
  & > tbody > tr:last-child {
    border-bottom: none;
  }
  & > tbody > tr > td:nth-child(1) {
    font-size: 13px;
  }

  & > tbody > tr > td:nth-child(3) {
    font-size: 15px;
    text-align: right;
    font-weight: bold;
    & > em {
      font-size: 10px;
      margin: 0 5px;

      &.winner {
        color: #ee1a21;
      }
    }
  }
  & > tbody > tr > td:nth-child(4) {
    font-size: 15px;
    text-align: center;
  }
  & > tbody > tr > td:nth-child(5) {
    font-size: 15px;
    text-align: left;
    font-weight: bold;
    & > em {
      font-size: 10px;
      margin: 0 5px;
      &.winner {
        color: #ee1a21;
      }
    }
  }

  & > tbody > tr > td:nth-child(2) {
    text-align: right;
    padding-left: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
  }
  & > tbody > tr > td:nth-child(6) {
    padding-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
    font-size: 13px;
  }

  & > tbody > tr > td:nth-child(7) {
    text-align: left;
    padding: 0 10px;
    white-space: nowrap;
  }
`;

export const SubRow = styled.tr`
  background: #f1f2f4;
  & > td {
    height: auto;
    padding: 10px;
  }
`;

export const SubTable = styled.table`
  border-collapse: collapse;
  border: 1px solid #e4e4e4;
  width: 100%;
  table-layout: fixed;

  background: #fff;
  & > thead th {
    height: 34px;
    font-size: 12px;
    background: #f2f2f2;
    border-bottom: 1px solid #e4e4e4;
  }

  & > tbody td {
    height: 33px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
  }

  & > tbody th {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    text-align: left;
    padding-left: 10px;
    max-width: 100%;
  }

  & > tfoot > tr {
    border-top: 1px solid #f2f2f2;
  }
  
  & > tfoot th {
    font-size: 12px;
    text-align: left;
    padding-left: 10px;
    max-width: 100%;
  }
  
  & > tfoot td {
    height: 30px;
    font-size: 12px;
  }
  
  & > tfoot td.result {
    padding-right:10px;
    text-align:right;
  }
`;

export const ResultBadge = styled.span`
  display: inline-block;
  width: 40px;
  height: 15px;
  vertical-align: middle;
  text-align: center;
  line-height: 15px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: #fff;
  font-size: 12px;
  letter-spacing: -1px;
  &:not(:last-child) {
    margin-right: 4px;
  }
  ${(props) =>
    props.position === 'home'
      ? css`
          color: #ee1a21;
          border-color: #ee1a21;
        `
      : css`
          color: #2a83ff;
          border-color: #2a83ff;
        `}
`;
